import React, { useState } from 'react';

// Ashop Rotterdam legal / tax details — matches the paper form
const SHOP = {
  name: 'Ashop Rotterdam',
  legalName: 'A Shop',
  tagline: 'Phones · Money Transfer · Print Services',
  address: 'Schiedamseweg 159A, 3026AK Rotterdam',
  kvk: '68280939',
  btw: 'NL002355010B65',
  phone: '+31 6 14359710',
  email: 'shabazbaig786@gmail.com',
};

const BLANK_ROW = { details: '', qty: '', price: '' };
const ROWS = 12;

const todayStr = () => {
  const d = new Date();
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

const invoiceNumberFor = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const rand = String(Math.floor(1000 + Math.random() * 9000));
  return `ASH-${y}${m}${day}-${rand}`;
};

const TaxForm = () => {
  const [date, setDate] = useState(todayStr());
  const [customerName, setCustomerName] = useState('');
  const [invoiceNo] = useState(() => invoiceNumberFor(new Date()));
  const [rows, setRows] = useState(Array.from({ length: ROWS }, () => ({ ...BLANK_ROW })));

  const setRow = (i, key) => (e) => {
    const val = e.target.value;
    setRows((prev) => prev.map((r, idx) => idx === i ? { ...r, [key]: val } : r));
  };

  const clearAll = () => {
    setRows(Array.from({ length: ROWS }, () => ({ ...BLANK_ROW })));
    setCustomerName('');
    setDate(todayStr());
  };

  // Price entered is EX-BTW (base price). BTW 21% is added on top. Total = price × qty × 1.21.
  // Qty defaults to 1 if left blank so a single-line "Item · €56" works with just the price filled.
  const compute = (r) => {
    const rawQty = parseFloat(r.qty);
    const qty = isNaN(rawQty) || rawQty <= 0 ? 1 : rawQty;
    const price = parseFloat(r.price) || 0;
    const base = qty * price;
    const btw = base * 0.21;
    const total = base + btw;
    return { base, btw, total, effectiveQty: qty };
  };

  const grandBase = rows.reduce((s, r) => s + compute(r).base, 0);
  const grandBtw = rows.reduce((s, r) => s + compute(r).btw, 0);
  const grand = grandBase + grandBtw;
  const anyData = rows.some((r) => r.details.trim() || r.qty || r.price);
  const filledCount = rows.filter((r) => r.details.trim() || r.qty || r.price).length;

  const escape = (v) => String(v || '').replace(/[<>&]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]));
  const fmt = (n) => n > 0 ? n.toFixed(2) : '0.00';

  const handlePrint = () => {
    const w = window.open('', '_blank');
    if (!w) {
      alert('Please allow pop-ups to print the tax invoice.');
      return;
    }
    const rowsHtml = rows.filter((r) => r.details.trim() || r.qty || r.price).map((r, i) => {
      const { btw, total, effectiveQty } = compute(r);
      const unitIncl = effectiveQty > 0 ? total / effectiveQty : 0;
      return `<tr>
        <td class="c-num">${i + 1}</td>
        <td class="c-det">${escape(r.details)}</td>
        <td class="c-qty">${effectiveQty}</td>
        <td class="c-price">€ ${fmt(unitIncl)}</td>
        <td class="c-btw">€ ${fmt(btw)}</td>
        <td class="c-tot">€ ${fmt(total)}</td>
      </tr>`;
    }).join('');

    w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8" />
      <title>Tax Invoice ${invoiceNo} · ${SHOP.name}</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #1f2937; background: #fff; padding: 26px; }
        .sheet { max-width: 820px; margin: 0 auto; border: 3px solid #1e3a8a; border-radius: 14px; overflow: hidden; }
        .header { background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 50%, #2563eb 100%); color: #fff; padding: 22px 28px; display: flex; justify-content: space-between; align-items: flex-start; }
        .shop-name { font-size: 22px; font-weight: 800; letter-spacing: -0.02em; }
        .shop-sub { font-size: 11px; opacity: 0.85; margin-top: 2px; }
        .shop-contact { font-size: 11px; opacity: 0.85; margin-top: 8px; line-height: 1.7; }
        .stamp { text-align: right; }
        .stamp .badge { display: inline-block; background: #fbbf24; color: #78350f; padding: 6px 12px; border-radius: 7px; font-weight: 900; font-size: 12px; letter-spacing: 2px; text-transform: uppercase; border: 2px solid #fef3c7; }
        .stamp .invno { font-family: 'Menlo', monospace; font-size: 12px; opacity: 0.9; margin-top: 8px; }
        .stamp .date { font-size: 12px; opacity: 0.9; margin-top: 3px; }

        .id-bar { background: #eef2ff; border-bottom: 2px solid #c7d2fe; padding: 10px 28px; display: flex; justify-content: space-between; font-size: 12px; font-weight: 700; color: #1e3a8a; }
        .id-bar .item span { color: #64748b; font-weight: 600; margin-right: 6px; text-transform: uppercase; letter-spacing: 0.7px; font-size: 10px; }

        .customer { padding: 10px 28px; font-size: 13px; color: #475569; border-bottom: 1px solid #e2e8f0; }
        .customer strong { color: #1e3a8a; margin-right: 8px; }

        table { width: 100%; border-collapse: collapse; }
        thead th { background: #1e3a8a; color: #fff; padding: 10px 12px; font-size: 11px; text-transform: uppercase; letter-spacing: 0.7px; text-align: left; }
        thead th.c-qty, thead th.c-num { text-align: center; }
        thead th.c-price, thead th.c-btw, thead th.c-tot { text-align: right; }
        tbody td { padding: 10px 12px; border-bottom: 1px solid #e2e8f0; font-size: 13px; }
        tbody .c-num { text-align: center; color: #94a3b8; font-weight: 600; width: 40px; }
        tbody .c-det { font-weight: 500; }
        tbody .c-qty { text-align: center; width: 60px; }
        tbody .c-price, tbody .c-btw { text-align: right; color: #475569; width: 100px; }
        tbody .c-tot { text-align: right; font-weight: 700; width: 110px; }

        .totals { padding: 14px 28px; background: #f8fafc; }
        .totals-row { display: flex; justify-content: flex-end; margin-bottom: 6px; font-size: 13px; color: #475569; }
        .totals-row .lbl { width: 200px; text-align: right; padding-right: 16px; }
        .totals-row .val { width: 130px; text-align: right; font-family: 'Menlo', monospace; font-weight: 700; color: #1e293b; }
        .totals-row.grand { padding-top: 12px; border-top: 2px solid #1e3a8a; margin-top: 6px; }
        .totals-row.grand .lbl { font-size: 15px; color: #1e3a8a; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; }
        .totals-row.grand .val { font-size: 20px; color: #1e3a8a; }

        .footer { background: #1e3a8a; color: #dbeafe; padding: 10px 28px; text-align: center; font-size: 10px; letter-spacing: 1px; text-transform: uppercase; }
        .footer div { opacity: 0.85; margin-top: 2px; font-size: 9px; letter-spacing: 0.5px; text-transform: none; }
        @media print {
          body { padding: 0; }
          .sheet { border-radius: 0; border: 2px solid #1e3a8a; }
        }
      </style></head><body>
      <div class="sheet">
        <div class="header">
          <div>
            <div class="shop-name">${SHOP.name}</div>
            <div class="shop-sub">${SHOP.tagline}</div>
            <div class="shop-contact">
              ${SHOP.address}<br />
              ${SHOP.phone} &nbsp;·&nbsp; ${SHOP.email}
            </div>
          </div>
          <div class="stamp">
            <span class="badge">Tax Invoice</span>
            <div class="invno">${invoiceNo}</div>
            <div class="date">${escape(date)}</div>
          </div>
        </div>
        <div class="id-bar">
          <div class="item"><span>KVK</span>${SHOP.kvk}</div>
          <div class="item"><span>BTW</span>${SHOP.btw}</div>
        </div>
        ${customerName.trim() ? `<div class="customer"><strong>Customer</strong> ${escape(customerName)}</div>` : ''}
        <table>
          <thead>
            <tr>
              <th class="c-num">#</th>
              <th>Description</th>
              <th class="c-qty">Qty</th>
              <th class="c-price">Price €</th>
              <th class="c-btw">BTW 21%</th>
              <th class="c-tot">Total</th>
            </tr>
          </thead>
          <tbody>${rowsHtml || '<tr><td colspan="6" style="padding:24px;text-align:center;color:#94a3b8;">No line items</td></tr>'}</tbody>
        </table>
        <div class="totals">
          <div class="totals-row"><div class="lbl">Subtotal (excl. BTW)</div><div class="val">€ ${fmt(grandBase)}</div></div>
          <div class="totals-row"><div class="lbl">BTW 21% (added)</div><div class="val">€ ${fmt(grandBtw)}</div></div>
          <div class="totals-row grand"><div class="lbl">Total (incl. BTW)</div><div class="val">€ ${fmt(grand)}</div></div>
        </div>
        <div class="footer">Thank you for shopping with ${SHOP.name}<div>KVK ${SHOP.kvk} · BTW ${SHOP.btw}</div></div>
      </div>
      <script>window.addEventListener('load', function(){ setTimeout(function(){ window.focus(); window.print(); }, 350); });</script>
      </body></html>`);
    w.document.close();
  };

  return (
    <div className="bg-white text-slate-900 rounded-2xl shadow-xl overflow-hidden border-4 border-blue-900" data-testid="taxform-panel">
      {/* Action strip */}
      <div className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-600 px-6 py-4 flex items-center justify-between gap-4">
        <div className="text-white">
          <p className="text-[10px] font-bold uppercase tracking-[0.35em] opacity-80">Dutch BTW Invoice</p>
          <h2 className="text-lg font-black tracking-tight">Tax Invoice · {SHOP.name}</h2>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={clearAll}
            className="px-4 py-2.5 bg-white/10 hover:bg-white/20 border border-white/20 rounded-lg text-white font-semibold text-sm transition-all"
            data-testid="taxform-clear-btn"
          >
            <i className="fas fa-eraser mr-1"></i> Clear
          </button>
          <button
            onClick={handlePrint}
            disabled={!anyData}
            className={`px-5 py-2.5 rounded-lg font-bold text-sm transition-all shadow-lg ${anyData ? 'bg-amber-400 hover:bg-amber-500 text-amber-900' : 'bg-white/10 text-white/40 cursor-not-allowed'}`}
            data-testid="taxform-print-btn"
          >
            <i className="fas fa-print mr-1"></i> Print Tax Invoice
          </button>
        </div>
      </div>

      {/* Sub-header with shop identity */}
      <div className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-600 px-6 pb-6 text-white flex justify-between items-end border-b-4 border-amber-400">
        <div>
          <h1 className="text-2xl font-black tracking-tight">{SHOP.name}</h1>
          <p className="text-xs opacity-85 mt-0.5">{SHOP.tagline}</p>
          <p className="text-xs opacity-80 mt-2 leading-relaxed">
            {SHOP.address}<br />
            {SHOP.phone} · {SHOP.email}
          </p>
        </div>
        <div className="text-right">
          <span className="inline-block bg-amber-400 text-amber-900 px-3 py-1 rounded-lg font-black text-[10px] uppercase tracking-widest border-2 border-amber-200">
            Tax Invoice
          </span>
          <p className="text-[11px] font-mono opacity-90 mt-2 tracking-wider" data-testid="invoice-number">{invoiceNo}</p>
          <div className="flex items-center justify-end gap-2 mt-1">
            <span className="text-[10px] opacity-80 uppercase tracking-wider">Date</span>
            <input
              type="text"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="bg-transparent border-b border-white/40 focus:border-white outline-none text-xs font-mono text-right w-28 text-white placeholder-white/40"
              data-testid="taxform-date"
            />
          </div>
        </div>
      </div>

      {/* KVK / BTW bar */}
      <div className="bg-indigo-50 border-b-2 border-indigo-200 px-6 py-3 flex flex-wrap justify-between items-center gap-3 text-sm">
        <div className="flex items-center gap-2">
          <span className="text-[10px] uppercase tracking-widest text-indigo-500 font-bold">KVK</span>
          <span className="font-mono font-bold text-blue-900">{SHOP.kvk}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-[10px] uppercase tracking-widest text-indigo-500 font-bold">BTW</span>
          <span className="font-mono font-bold text-blue-900">{SHOP.btw}</span>
        </div>
      </div>

      {/* Customer row */}
      <div className="px-6 py-3 border-b border-slate-200 flex items-center gap-3">
        <span className="text-[10px] uppercase tracking-widest text-blue-900 font-bold w-20">Customer</span>
        <input
          type="text"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
          placeholder="Optional — walk-in customer or business name"
          className="flex-1 px-3 py-2 border border-slate-200 rounded-lg text-sm focus:border-blue-600 focus:outline-none"
          data-testid="taxform-customer"
        />
      </div>

      {/* Line items table */}
      <div className="px-6 py-4">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-blue-900 text-white">
                <th className="py-2.5 px-2 text-center rounded-tl-lg w-12 text-[10px] uppercase tracking-widest font-bold">#</th>
                <th className="py-2.5 px-3 text-left text-[10px] uppercase tracking-widest font-bold">Description</th>
                <th className="py-2.5 px-2 text-center w-20 text-[10px] uppercase tracking-widest font-bold">Qty</th>
                <th className="py-2.5 px-2 text-right w-32 text-[10px] uppercase tracking-widest font-bold">Price €</th>
                <th className="py-2.5 px-2 text-right w-28 text-[10px] uppercase tracking-widest font-bold">BTW 21%</th>
                <th className="py-2.5 px-2 text-right w-32 rounded-tr-lg text-[10px] uppercase tracking-widest font-bold">Total</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => {
                const { btw, total } = compute(r);
                const rowHasData = r.details.trim() || r.qty || r.price;
                return (
                  <tr key={i} className={`border-b border-slate-100 ${rowHasData ? 'bg-white' : 'bg-slate-50/50'}`} data-testid={`taxform-row-${i}`}>
                    <td className="px-2 text-center align-middle text-xs text-slate-400 font-semibold w-12">
                      {rowHasData ? i + 1 : ''}
                    </td>
                    <td className="px-1 py-1">
                      <input
                        type="text"
                        value={r.details}
                        onChange={setRow(i, 'details')}
                        placeholder={i === 0 ? 'e.g. Samsung A54 128GB' : ''}
                        className="w-full px-2 py-2 rounded-md border border-transparent hover:border-slate-200 focus:border-blue-500 focus:bg-blue-50/40 focus:outline-none text-sm"
                        data-testid={`taxform-details-${i}`}
                      />
                    </td>
                    <td className="px-1 py-1 relative">
                      <input
                        type="text"
                        inputMode="decimal"
                        value={r.qty}
                        onChange={setRow(i, 'qty')}
                        placeholder={r.price ? '1' : ''}
                        className="w-full px-2 py-2 rounded-md border border-transparent hover:border-slate-200 focus:border-blue-500 focus:bg-blue-50/40 focus:outline-none text-center font-mono text-sm placeholder-slate-300"
                        data-testid={`taxform-qty-${i}`}
                      />
                    </td>
                    <td className="px-1 py-1">
                      <div className="relative">
                        <span className="absolute left-2 top-1/2 -translate-y-1/2 text-slate-400 text-xs">€</span>
                        <input
                          type="text"
                          inputMode="decimal"
                          value={r.price}
                          onChange={setRow(i, 'price')}
                          className="w-full pl-6 pr-2 py-2 rounded-md border border-transparent hover:border-slate-200 focus:border-blue-500 focus:bg-blue-50/40 focus:outline-none text-right font-mono text-sm"
                          data-testid={`taxform-price-${i}`}
                        />
                      </div>
                    </td>
                    <td className="px-2 py-2 text-right text-xs tabular-nums text-slate-500">
                      {btw > 0 ? `€ ${fmt(btw)}` : <span className="text-slate-300">—</span>}
                    </td>
                    <td className="px-2 py-2 text-right text-sm tabular-nums font-bold text-blue-900">
                      {total > 0 ? `€ ${fmt(total)}` : <span className="text-slate-300 font-normal">—</span>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Totals */}
      <div className="px-6 pb-6">
        <div className="bg-gradient-to-br from-indigo-50 to-blue-50 border-2 border-indigo-200 rounded-xl p-5">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-blue-900 rounded-lg flex items-center justify-center">
                <i className="fas fa-calculator text-white text-sm"></i>
              </div>
              <p className="text-xs uppercase tracking-widest text-blue-900 font-bold">Totals · Auto-calculated</p>
            </div>
            <span className="text-[10px] font-mono uppercase tracking-widest text-slate-400">
              {filledCount} line{filledCount === 1 ? '' : 's'}
            </span>
          </div>
          <div className="space-y-1.5">
            <div className="flex justify-between items-center text-sm">
              <span className="text-slate-600">Subtotal (excl. BTW)</span>
              <span className="font-mono font-bold text-slate-900 tabular-nums" data-testid="taxform-subtotal">€ {fmt(grandBase)}</span>
            </div>
            <div className="flex justify-between items-center text-sm">
              <span className="text-slate-600">BTW 21% (added)</span>
              <span className="font-mono font-bold text-slate-900 tabular-nums" data-testid="taxform-btw">€ {fmt(grandBtw)}</span>
            </div>
            <div className="flex justify-between items-center pt-3 mt-2 border-t-2 border-blue-900">
              <span className="font-black text-blue-900 uppercase tracking-widest text-xs">Total (incl. BTW)</span>
              <span className="font-mono font-black text-2xl text-blue-900 tabular-nums" data-testid="taxform-grand-total">€ {fmt(grand)}</span>
            </div>
          </div>
        </div>
        <p className="text-[11px] text-slate-500 mt-3 flex items-center gap-2">
          <i className="fas fa-info-circle"></i>
          Enter the <strong>base price (excl. BTW)</strong>. The system adds 21% BTW on top and shows the total automatically.
        </p>
      </div>

      {/* Footer */}
      <div className="bg-blue-900 text-blue-100 px-6 py-2.5 text-center text-[10px] uppercase tracking-[0.2em]">
        {SHOP.name} · KVK {SHOP.kvk} · BTW {SHOP.btw}
      </div>
    </div>
  );
};

export default TaxForm;
